import FocusableIconButton from '@components/FocusableIconButton';
import { useTreatmentHistoryContext } from '@context/TreatmentHistory';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import {
  TREATMENT_HISTORY_EMPTY,
  TREATMENT_HISTORY_HOME
} from '@pages/TreatmentHistory/focusKey';
import { useEffect } from 'react';

import * as styles from './styles';

const EmptyContents = () => {
  const { setEmptyListFocus, goHome } = useTreatmentHistoryContext();

  const { ref } = useFocusable({ focusKey: TREATMENT_HISTORY_EMPTY });

  useEffect(() => {
    setEmptyListFocus();
  }, [setEmptyListFocus]);

  return (
    <FocusContext.Provider value={TREATMENT_HISTORY_EMPTY}>
      <div ref={ref} css={styles.container}>
        <div css={styles.mainContainer}>
          <p css={styles.title}>진료내역이 없습니다</p>
          <p css={styles.description}>
            원하는 항목을 선택하고 지금 비대면 진료를 받아보세요
          </p>
        </div>
        <div css={styles.bottomContainer}>
          <FocusableIconButton
            focusKey={TREATMENT_HISTORY_HOME}
            onEnterPress={goHome}
            iconType="arrow"
          >
            홈으로
          </FocusableIconButton>
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default EmptyContents;
